import React, { useState } from "react";
import "./Footer.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Button,
  Slider,
  Checkbox,
  Dropdown_aspect,
  ColorPicker,
  NumberInput,
} from "../../../Components/";
import { useSelector, useDispatch } from "react-redux";
import {
  updateSettingOptionState,
  saveProjectSettings,
  updateProjectCreditsByGoogle,
  updateProjectCredits,
} from "../../../Redux/actions/projectActions";
import CloneProjectModal from "../CloneProject/CloneProjectModal";
import Render from "../Render/Render";
import RenderNew from "../Render/RenderNew";
import { selectedPageOption, setGlobalColorInReudx } from "../../../Redux/actions/commonActtion";
import CardRender from "../Cards/CardRender";
import { AiOutlineGlobal } from "react-icons/ai";
import CustomToast, {customToatStyle,
  customToatStyleError,
} from "../../../Components/CustomToast/CustomToast";
import { read, utils } from "xlsx";
import { excelDataToCredits } from "../../../services/excelDataToProjectData";
import { CreditBtnIcon, SyncNav } from "../../../assets/icons";
import { useLocation, useNavigate } from "react-router-dom";
const debounceTimeoutIds = {};

const getUpdatedProjectCredits = (currentCredits, newCredits) => {
  try {
    const updatedCredits = newCredits;
    for (let i = 0; i < newCredits.length; i++) {
      let idx = currentCredits.findIndex(
        (credit) =>
          credit.options.block_name == newCredits[i].options.block_name
      );
      if (
        idx !== -1 &&
        currentCredits[idx].options.block_type ==
          newCredits[i].options.block_type
      ) {
        updatedCredits[i].options = currentCredits[idx].options;
      }
    }
    return { data: updatedCredits };
  } catch (error) {
    return { error, data: null };
  }
};

const Footer = ({
  currentBlockOptions,
  isTitleSafe,
  setIsTitleSafe,
  getBlockSize,
  aspectRatio_FrameSize,
  setAspectRatio_FrameSize,
  handleFooterClick,
  isCard,
  setIsDisplayTitle,
  isDisplayTitle,
  isRenderExport,
  setIsRenderExport,
  setReLoading,
}) => {
  // console.log('currentBlockOptions  = ',currentBlockOptions?.text_alignment==='gutter' || currentBlockOptions?.text_alignment==='ragged'
  // )
  const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    let {isDashboard} = location?.state;
    // console.log('Footer location = ',isDashboard ,location);

  const [selectedID, setSelectedID] = useState("");
  const {
    googleSheetLink,
    _id,
    googleSpreadSheetId,
    credits: currentCredits,
    currentBlock,
  } = useSelector((state) => state?.project);
  const projectSettings = useSelector((state) => state.project.settings);

  const [renderOpen, setRenderOpen] = useState(false);
  const [projectCloneModalOpen, setProjectCloneModalOpen] = useState(false);
  const [options, setOptions] = useState([
    { label: "NONE", value: "hdnone" },
    { label: "1.33", value: "Class1x33" },
    { label: "1.78", value: "Class1x78" },
    { label: "1.85", value: "Class1x85" },
    { label: "1.9", value: "Class1x9" },
    { label: "2.35", value: "Class2_35x1" },
    { label: "2.39", value: "Class2x39" },
  ]);

  const { gobalBGcolor } = useSelector((state) => state?.commonReducer);
  const updateProjectSettingsState = (key, value) =>
    dispatch(updateSettingOptionState(key, value));
  const saveProjectSettingsCall = () => dispatch(saveProjectSettings());
  // const debouncedSettingsSave = debounce(saveProjectSettingsCall, 1000);
  const debouncedSave = (key, value) => {
    if (debounceTimeoutIds[key]) {
      clearTimeout(debounceTimeoutIds[key]);
      debounceTimeoutIds[key] = null;
    }
    debounceTimeoutIds[key] = setTimeout(() => {
      saveProjectSettingsCall(key, value);
    }, 1500);
  };

  const handleGoogleUpdate = async () => {
    await setReLoading({ condn: true, label: "Syncing..." });

    try {
      const res = await dispatch(
        updateProjectCreditsByGoogle(
          _id,
          googleSpreadSheetId,
          currentCredits,
          isCard
        )
      );
      if (res?.success === true) {
        await setReLoading({ condn: false, label: "" });
        setTimeout(() => {
          toast(
            <CustomToast title="" content={res?.message} />,
            customToatStyle
          );
        }, 300);
      } else {
        await setReLoading({ condn: false, label: "" });
        setTimeout(() => {
          toast(
            <CustomToast
              title={res?.response?.data?.title}
              content={res?.response?.data?.message}
            />,
            customToatStyleError
          );
        }, 2000);
      }
    } catch (err) {
      await setReLoading({ condn: false, label: "" });
    }
  };

  const handleFileInput = (file) => {
    try {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const binaryStr = evt.target.result;
        const wb = read(binaryStr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const jsonData = utils.sheet_to_json(ws, { header: 1 });
        const newCredits = excelDataToCredits(jsonData);
        const { data: updatedCredits, error } = getUpdatedProjectCredits(
          currentCredits,
          newCredits
        );
        if (error) {
          return error;
        }
        dispatch(updateProjectCredits(_id, updatedCredits));
      };
      reader.readAsBinaryString(file);
    } catch (err) {
      return err;
    }
  };

  const OptionHandler = (val) => {
    dispatch(selectedPageOption(val, _id, isCard));
    navigate("", {
      state: {isDashboard: isDashboard, isRender:true, projectId: _id, isCard: isCard? isCard: false,},
      replace: true
    });
  };

  return (
    <>
      <div className="main-footer">
        <div className="leftBottom"></div>

        <div className="centerBottom ">
          {/* BG Global Color code start here */}
          {/* <div className="Gutter">
          <div >
            <input
              type="color"
              className="colorPickerLabel"
              value={gobalBGcolor}
              onChange={(evt) => {
                dispatch(setGlobalColorInReudx(evt.target.value));
              }}
              onBlur={() => dispatch(setGlobalColorInReudx(gobalBGcolor))}
            />
            <input
              type="text"
              id="colors"
              className="colorPickerInputsText drop-shadow-2xl"
              name="color"
              value={gobalBGcolor}
              onChange={(evt) => {
                dispatch(setGlobalColorInReudx(evt.target.value));
              }}
              onBlur={() => dispatch(setGlobalColorInReudx(gobalBGcolor))}
            />
          </div>
        </div> */}

          {currentBlockOptions?.text_alignment === "ragged" ? (
            <div className="Gutter  ">
              <NumberInput
                label="Ragged Gutter"
                postLabel="px"
                value={projectSettings?.ragged_gutter}
                onChange={(val) => {
                  updateProjectSettingsState("ragged_gutter", val);
                  debouncedSave();
                }}
                min={0}
                max={15}
              />
            </div>
          ) : currentBlockOptions?.text_alignment === "center" ||
            currentBlockOptions?.text_alignment === "gutter" ? (
            <div className="Gutter">
              <NumberInput
                label="Gutter"
                postLabel="px"
                value={projectSettings?.gutter}
                onChange={(val) => {
                  updateProjectSettingsState("gutter", val);
                  debouncedSave();
                }}
                min={0}
                max={15}
              />
              {/* <label htmlFor="global" className="text-[1.6rem] ml-[-17px]  ">
              <AiOutlineGlobal />
            </label> */}
            </div>
          ) : null}

          {isCard ? (
            ""
          ) : (
            <div className="flex items-center justify-center">
              <div
                className="w-full h-full flex align-center"
                style={{
                  marginRight:
                    currentBlockOptions?.text_alignment === "center" ||
                    currentBlockOptions?.text_alignment === "gutter"
                      ? ""
                      : "25px",
                }}
              >
                <Dropdown_aspect
                  options={options}
                  value={aspectRatio_FrameSize}
                  aspectRatio_FrameSize={aspectRatio_FrameSize}
                  setAspectRatio_FrameSize={setAspectRatio_FrameSize}
                  label={"Aspect ratio"}
                  selectedID={selectedID}
                  onChange={(value) => {
                    getBlockSize("aspectRatio_frame", value);

                    const idx = options.findIndex((opt) => opt.value === value);
                    if (idx !== -1) {
                      setSelectedID(idx);
                    }
                    // if (idx !== -1) {
                    //   const updatedOptions = [
                    //     options[idx],
                    //     ...options.slice(0, idx),
                    //     ...options.slice(idx + 1),
                    //   ];

                    //   setOptions(updatedOptions);
                    // }
                  }}
                />
              </div>
            </div>
          )}

          {isCard ? (
            ""
          ) : (
            <div
              className="flex justify-center text-2xl mx-[20px]"
              style={{
                display:
                  currentBlockOptions?.text_alignment === "center" ||
                  currentBlockOptions?.text_alignment === "gutter"
                    ? ""
                    : "none",
              }}
            >
              <span className="h-[20px] border-r-[1px] border-[#a1a1a2]" />
            </div>
          )}

          {!isCard && (
            <div className="Title-safe">
              <Checkbox
                label={"Title safe"}
                isTitleSafe={isTitleSafe}
                setIsTitleSafe={setIsTitleSafe}
              />
            </div>
          )}

          {isCard && (
            <div className="Title-safe">
              <Checkbox
                label={"Title safe"}
                isDisplayTitle={isDisplayTitle}
                setIsDisplayTitle={setIsDisplayTitle}
              />
            </div>
          )}
        </div>

        <div className="rightBottom">
          <div className="w-[100%] flex justify-center items-center px-[30px]">
          {/* <Button
            type="button"
            buttonSize="btn--size"
            buttonStyle="btn--solid"
            bgColor={"#373843"}
            onClick={() => window.open(googleSheetLink)}
          >
            <p className="flex justify-between items-center">
              <img className="ftr-btn" src={CreditBtnIcon} alt="" />
              <span className="">Credit Sheet</span>
            </p>
          </Button> */}

          {/* {googleSheetLink ? (
            <Button
              type="button"
              buttonSize="btn--size"
              buttonStyle="btn--solid"
              bgColor={"#373843"}
              onClick={handleGoogleUpdate}
            >
              <p className="flex justify-between items-center">
                <img className="ftr-btn" src={SyncNav} alt="" />
                <span>Sync Credits</span>
              </p>
            </Button>
          ) : (
            <Button
              type="button"
              buttonSize="btn--size"
              buttonStyle="btn--solid"
              bgColor={"#373843"}
              handleFileInput={handleFileInput}
            >
              <p className="flex justify-between items-center">
                <img className="ftr-btn" src={SyncNav} alt="" />
                <span>Sync Credits</span>
              </p>
            </Button>
          )} */}

          {/* <Button type="button" buttonStyle="btn--solid" buttonSize="btn--size" onClick={handleFooterClick}> span className="uppercase Syne700">Preview</span></Button> */}

          <Button type="button" buttonStyle="btn--solid" buttonSize="btn--size"

            // bgColor={"#413caa"}
            customebackground = {`linear-gradient(45deg,rgb(48, 42, 95),rgb(88, 80, 165))`}
            customWidth={'100%'} 

            onClick={() => {setRenderOpen(true); OptionHandler("renderPage")}}
          >
            <p className="flex justify-center items-center p-0"><span className="ftr-rbtn">Render Settings</span></p>
            
          </Button>
          </div>
        </div>

        <CloneProjectModal
          projectCloneModalOpen={projectCloneModalOpen}
          setProjectCloneModalOpen={setProjectCloneModalOpen}
        />
      </div>

      {renderOpen && !isCard && (
        <RenderNew
          renderOpen={renderOpen}
          setRenderOpen={setRenderOpen}
          currentBlockIdx={currentBlock?.idx}
          isRenderExport={isRenderExport}
          setIsRenderExport={setIsRenderExport}
        />
      )}

      {renderOpen && isCard && (
        <CardRender
          renderOpen={renderOpen}
          setRenderOpen={setRenderOpen}
          currentBlockIdx={currentBlock?.idx}
          isRenderExport={isRenderExport}
          setIsRenderExport={setIsRenderExport}
          isCard={isCard}
        />
      )}
    </>
  );
};

export default Footer;
